export default __webpack_public_path__ + "static/media/Flash.71209221.svg";